/* unplugin-vue-components disabled */import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.number.constructor.js";
import useMortarList from '../hooks/useMortarList';
import useShangTongList from '../hooks/useShangTongList';
export default defineComponent({
  name: 'SalePrice',
  components: {},
  props: {
    type: {
      type: Number,
      default: 1
    }
  },
  setup: function setup(props) {
    watch(function () {
      return props.type;
    }, function (newVal) {
      console.log(222, props.type);
      activeName.value = undefined;
      if (newVal === 1) {
        shangTongList.value = [];
        getCommercialSalesAsync();
      }
      if (newVal === 2) {
        mortarList.value = [];
        getMortarSalesAsync();
      }
    });
    var params = ref({
      stoneName: ''
    });
    var _useMortarList = useMortarList(params),
      _useMortarList2 = _slicedToArray(_useMortarList, 4),
      mortarList = _useMortarList2[0],
      mortarPriceList = _useMortarList2[1],
      getMortarSalesAsync = _useMortarList2[2],
      getMortarPriceForStoneAsync = _useMortarList2[3];
    var _useShangTongList = useShangTongList(params),
      _useShangTongList2 = _slicedToArray(_useShangTongList, 4),
      shangTongList = _useShangTongList2[0],
      shangTongPriceList = _useShangTongList2[1],
      getCommercialSalesAsync = _useShangTongList2[2],
      getCommercialPriceForStoneAsync = _useShangTongList2[3];
    var onChange = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(stone_name) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              params.value.stoneName = stone_name;
              if (props.type === 1) {
                shangTongPriceList.value = [];
                getCommercialPriceForStoneAsync();
              }
              if (props.type === 2) {
                mortarPriceList.value = [];
                getMortarPriceForStoneAsync();
              }
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function onChange(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    var list = computed(function () {
      var list = [];
      if (props.type === 1) {
        list = shangTongList.value;
      }
      if (props.type === 2) {
        list = mortarList.value;
      }
      return list;
    });
    var priceList = computed(function () {
      var list = [];
      if (props.type === 1) {
        list = shangTongPriceList.value;
      }
      if (props.type === 2) {
        list = mortarPriceList.value;
      }
      return list;
    });
    onMounted(function () {
      getMortarSalesAsync();
      getCommercialSalesAsync();
    });
    var activeName = ref();
    var onCommercialMortalChange = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(index) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (index || index === 0) {
                if (props.type === 1) {
                  getCommercialSalesAsync();
                } else {
                  getMortarSalesAsync();
                }
              }
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function onCommercialMortalChange(_x2) {
        return _ref2.apply(this, arguments);
      };
    }();
    return {
      activeName: activeName,
      onCommercialMortalChange: onCommercialMortalChange,
      mortarList: mortarList,
      mortarPriceList: mortarPriceList,
      shangTongList: shangTongList,
      shangTongPriceList: shangTongPriceList,
      list: list,
      priceList: priceList,
      onChange: onChange
    };
  }
});